import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { ReportDescription } from 'src/app/reports/interfaces/report.interface';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
	selector: 'app-report-description',
	templateUrl: './report-description-modal.component.html',
	styleUrls: ['./report-description-modal.component.scss'],
})
export class ReportDescriptionModalComponent {
	@Input() data: ReportDescription;

	constructor(
		private _modalController: ModalController,
		private _domSanitizer: DomSanitizer,
		private _translationService: TranslationService
	) {

	}

	public async dismiss() {
		await this._modalController.dismiss();
	}


}
